import BS from './BS.module.css'
const css = {...BS}
export default function ST (string = '') {
    return string.split(' ').map(v=> css[v] || v ).join(' ')
}